import { Module } from 'vuex'
import { RootState } from '@/store'
import { mutations } from '@/store/modules/price/mutations'
import { IPriceState, initialState } from '@/store/modules/price/state'

export * from '@/store/modules/price/state'

export const store: Module<IPriceState, RootState> = {
  state: initialState,
  mutations
}
